<template>
    <div>页面不存在</div>
</template>

<script>
    export default {
        name:"NotFund",
    }
</script>